import { render, staticRenderFns } from "./IncotermSettings.vue?vue&type=template&id=201c898d&scoped=true&"
import script from "./IncotermSettings.vue?vue&type=script&lang=js&"
export * from "./IncotermSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c898d",
  null
  
)

export default component.exports